import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledTableServiceMenu } from 'shell/view-models/disabled-menu';

interface TableServiceMenuProps {
  visibility?: DisabledTableServiceMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const TableServiceMenu = ({
  visibility = {
    tipoDoc: true,
    modalitaRilascio: true,
    ricercaRegistro: true,
    ricercaImporto: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: TableServiceMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Tabelle di servizio" />
      </ListItem>
      <Menu
        id="table-service-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.ricercaImporto
          ? [
              <MenuItem
                key="ricercaImporto-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/ricerca-importo');
                }}
              >
                <Typography variant="inherit">Gestione Importo</Typography>
              </MenuItem>,
              <Divider
                key="ricercaImporto-divider"
                hidden={
                  !visibility.modalitaRilascio && !visibility.ricercaRegistro && !visibility.tipoDoc
                }
              />,
            ]
          : undefined}
        {visibility.tipoDoc
          ? [
              <MenuItem
                key="tipoDoc-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/tipo-doc');
                }}
              >
                <Typography variant="inherit">Tipo Documento</Typography>
              </MenuItem>,
              <Divider
                key="tipoDoc-divider"
                hidden={!visibility.modalitaRilascio && !visibility.ricercaRegistro}
              />,
            ]
          : undefined}
        {visibility.modalitaRilascio
          ? [
              <MenuItem
                key="modalitaRilascio-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/modalita-rilascio');
                }}
              >
                <Typography variant="inherit">Modalità Rilascio</Typography>
              </MenuItem>,
              <Divider key="modalitaRilascio-divider" hidden={!visibility.ricercaRegistro} />,
            ]
          : undefined}
        {visibility.ricercaRegistro
          ? [
              <MenuItem
                key="ricercaRegistro-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/ricerca-registro');
                }}
              >
                <Typography variant="inherit">Gestione Registro</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

TableServiceMenu.displayName = 'Table Service Menu';

export default TableServiceMenu;
